import { useTranslation } from 'react-i18next';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { Shop } from './Shop/Shop';

export const Webshop = () => {
  const { t } = useTranslation();
  useSetPageTitle({
    title: t('Webshop', { ns: 'webshop' }),
    subtitle: t('Description', { ns: 'webshop' }),
  });
  return <Shop />;
};
